/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Inbound_Not_Ready_For_DispatchInputs */

const en_error_inbound_not_ready_for_dispatch = /** @type {(inputs: Error_Inbound_Not_Ready_For_DispatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The inbound cannot be sent to the warehouse and to Business Central yet: something they need is missing.`)
};

/**
* | output |
* | --- |
* | "The inbound cannot be sent to the warehouse and to Business Central yet: something they need is missing." |
*
* @param {Error_Inbound_Not_Ready_For_DispatchInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_inbound_not_ready_for_dispatch = /** @type {((inputs?: Error_Inbound_Not_Ready_For_DispatchInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Inbound_Not_Ready_For_DispatchInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_inbound_not_ready_for_dispatch(inputs)
});